import * as ActionTypes from '../ActionTypes';

// PMS Feedback Actions
export const GetPmsFeedbackAction = (params) => {
    return {
        type: ActionTypes.PMS_FEEDBACK_GET_REQUEST,
        params,
    };
};

export const AddPmsFeedbackAction = (params, callback) => {
    return {
        type: ActionTypes.PMS_FEEDBACK_ADD_REQUEST,
        params,
        callback,
    };
};

export const UpdatePmsFeedbackAction = (params, callback) => {
    return {
        type: ActionTypes.PMS_FEEDBACK_UPDATE_REQUEST,
        params,
        callback,
    };
};

export const DeletePmsFeedbackAction = (params) => {
    return {
        type: ActionTypes.PMS_FEEDBACK_DELETE_REQUEST,
        params,
    };
};
